import { Box, List, ListItem, ListItemText, Typography } from '@material-ui/core';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';

export const CustomFieldInfoDialog = ({ translate, onInfoDialogClose }) => {
	const fieldTypes = [
		{ type: "int", desc: translate("osfc.dialogs.custom_mapper_field.info.field_type.int") },
		{ type: "str", desc: translate("osfc.dialogs.custom_mapper_field.info.field_type.str") },
		{ type: "float", desc: translate("osfc.dialogs.custom_mapper_field.info.field_type.float") },
		{ type: "datetime", desc: translate("osfc.dialogs.custom_mapper_field.info.field_type.datetime") },
	  ];
	  
	return (
		<Dialog open maxWidth="md" onClose={onInfoDialogClose}>
			<DialogTitle>
				{translate("osfc.dialogs.custom_mapper_field.info.title")}
			</DialogTitle>
			<DialogContent>
						<Typography>
						   <span style={{ fontWeight: "bold", color:"#325aa8" }}>{translate("osfc.dialogs.custom_mapper_field.info.data_description")}:</span>
							{" "}
							<span style={{ fontWeight: "bold" }}>
								{"{row:custom_1}"}
							</span>
						</Typography>
						<Typography>
						<span style={{ fontWeight: "bold", color:"#325aa8" }}>{translate("osfc.dialogs.custom_mapper_field.info.value_description")}:</span>
							{" "}
							<span style={{ fontWeight: "bold" }}>
								<span style={{color:"#32a852"}}>field_name_in_source_doc</span><span style={{color:"#325aa8"}}>:field type:</span><span style={{color:"#c97f2a"}}>Name of heading</span>
							</span>
						</Typography>
						<Typography style={{ fontStyle: "italic" }}>
							{translate("osfc.dialogs.custom_mapper_field.info.separator_description")}
						</Typography>
						<Typography style={{ fontStyle: "italic" }}>
							{translate("osfc.dialogs.custom_mapper_field.info.example")}: Cargo_Colli:int:UNITS,Remarks:str:PALLETS
						</Typography>
						<br></br>
						<>
							<Typography>
								<span style={{ fontWeight: "bold", color:"#325aa8" }}>{translate("osfc.dialogs.custom_mapper_field.info.field_type.title")}:</span>
							</Typography>
							
							<List dense>
								{fieldTypes.map(({ type, desc }, index) => (
									<ListItem key={index} style={{ paddingLeft: 0 }}>
									<span style={{ marginRight: 8 }}>•</span>
									<ListItemText primary={<><code>{type}</code> ({desc})</>} />
									</ListItem>
								))}
							</List>
						</>
						<Typography>
						   <span style={{ fontWeight: "bold", color:"#325aa8" }}>{translate("osfc.dialogs.custom_mapper_field.info.summarize_info")}:</span> 
							{" "}
							<span style={{ fontWeight: "bold" }}>
								{"{sum:custom_1}"}
							</span>
						</Typography>
				
			</DialogContent>
			<DialogActions>
				<Button onClick={onInfoDialogClose} color="primary">
					{translate("ra.action.cancel")}
				</Button>
			</DialogActions>
		</Dialog>
	);
};

